import { useEffect, useRef, useState } from 'react';
import * as cTypes from 'config/ConfigTypes';
import { createPortal } from 'react-dom';
import './Modal.scss'

export default function Modal({ children, open, onClose, className = '' }) {
    const [displayed, setDisplayed] = useState(cTypes.NONE);
    useEffect(() => {
        if (open) setDisplayed(cTypes.BLOCK);
        else setDisplayed(cTypes.NONE);
    }, [open]);

    return createPortal(
        <div className="modal-overlay" onClose={onClose}
            style={{ display: displayed }}>
            <div className="modal-container">
                <div className={`appmodal ${className}`} >
                    {children}
                </div>
            </div>
        </div>, document.getElementById('modal')
    )
}